<template>
  <div class="page">
    <div  class="memory" v-show="showMemory" :style="{backgroundImage: 'url(' + publicPath + 'img/memory/bg.jpg)'}">
      <div class="head" :style="{backgroundImage: 'url(' + publicPath + 'img/memory/head.png)'}">
        <span id="found">{{selectedMemorys.length}}</span>
      </div>
      <div class="memory-box" :style="{backgroundImage: 'url(' + publicPath + 'img/memory/box.png)'}">
        <div class="memory-wrap" @scroll.passive="memoryScroll">
          <div>
            <div v-for="(memory, index) in memorys" :key="memory.id" class="memory-item" :class="{right: index % 2 === 1}" @click.stop="select(memory.id)" :data-id="memory.id">
              <div class="memory-icon-box" :class="{selected: memory.status}" :style="{backgroundImage: 'url(' + publicPath + 'img/memory/dot.png)'}"></div>
              <div class="memory-content">
                <div class="memory-content-box-bg">
                  <div class="white-bg-box">
                    <div class="white-bg"></div>
                  </div>
                </div>
                <div class="memory-content-box">
                  <div class="white-bg"></div>
                  <div class="memory-text" :style="{width: memory.id === 28 ? '5.6rem' : ''}">{{memory.text}}</div>
                  <div class="dot dot-1"></div>
                  <div class="dot dot-2"></div>
                  <div class="dot dot-3"></div>
                  <div class="dot dot-4"></div>
                </div>
              </div>
              <div class="memory-icon-wrap" :style="{backgroundImage: 'url(' + publicPath + 'img/poster/icon-bg.png)'}">
                <!-- width: iconSize + 'px', height: iconSize + 'px',  -->
                <div class="memory-icon" :style="{backgroundImage: 'url(' + memory.icon + ')', backgroundPosition: '-' + (memory.path % 10 * 3) + 'rem -' + (Math.floor(memory.path / 10) * 3) +'rem'}"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="memory-slider" :style="{backgroundImage: 'url(' + publicPath + 'img/memory/slider.png)', backgroundPosition: '0 ' + scrollProgress + '%'}"></div>
        <div class="memory-birds">
          <img class="bird-1" :src="publicPath + 'img/memory/bird-1.png'" alt="千纸鹤1" />
          <img class="bird-2" :src="publicPath + 'img/memory/bird-2.png'" alt="千纸鹤2" />
        </div>
        <!-- <div class="memory-replay" @click="backToTop">回到开头</div> -->
      </div>

      <div class="make-cloud" :style="{backgroundImage: 'url(' + publicPath + 'img/memory/cloud.png)'}">
        <div class="make-cloud-star" :style="{backgroundImage: 'url(' + publicPath + 'img/memory/star-down.png)'}"></div>
      </div>

      <div @click="makeMemory" class="make-btn" :class="{'grey': this.selectedMemorys.length === 0}" :style="{backgroundImage: 'url(' + publicPath + 'img/memory/make-btn.png)'}"></div>
    </div>
    <!-- v-show="showMaking" -->
    <div class="making" :style="{opacity: showMaking ? '1' : '0'}">
      <div id="factory" class="factory" :style="{backgroundImage: 'url(' + publicPath + 'img/poster/bg.jpg)'}">
        <img class="factory-bg" :src="publicPath + 'img/poster/bg.jpg'" alt="海报背景图片" />
        <div class="head-box" :sstyle="{backgroundImage: 'url(' + publicPath + 'img/poster/head.png)'}">
          <img class="head-box-bg" :src="publicPath + 'img/poster/head.png'" alt="海报头部" />
          <div v-if="this.headImage" class="head-image" :style="{backgroundImage: 'url(' + this.headImage + ')'}"></div>
          <div v-else class="head-image" :style="{backgroundImage: 'url(' + publicPath + 'img/poster/head-image.png)'}"></div>
          <div class="head-nickname">{{this.nickname}}</div>
        </div>
        <div class="factory-icons">
          <div class="factory-icon-item" v-for="memory in selectedMemorys" :key="memory.id">
            <div class="factory-icon-box">
              <img class="factory-icon-bg" :src="publicPath + 'img/poster/icon-bg.png'" alt="" />
              <div class="factory-icon-wrap">
                <img class="factory-icon" :src="publicPath + 'img/memory/icons.jpg'" alt="" :style="{top: '-' + (Math.floor(memory.path / 10) * 3) + 'rem', left: '-' + (memory.path % 10 * 3) + 'rem'}" />
              </div>
            </div>
            <div class="factory-icon-text">{{memory.text}}</div>
          </div>
        </div>
        <div class="factory-footer">
          <div class="factory-slogan-text">{{this.slogan}}</div>
          <img class="factory-qrcode" :src="publicPath + 'img/poster/qrcode.png'" alt="二维码地址" />
          <div class="factory-logo-area">
            <img class="factory-logo" :src="publicPath + 'img/poster/logo-china.png'" alt="中国网logo" />
            <!-- <img class="factory-logo" :src="publicPath + 'img/poster/logo-tencent.png'" alt="中国网logo" /> -->
            <!-- <img class="factory-source" :src="publicPath + 'img/poster/source.png'" alt="中国网出品信息" /> -->
          </div>
        </div>
      </div>

      <div class="making-tr" :style="{backgroundImage: 'url(' + publicPath + 'img/making/bg.jpg)'}">
        <div class="making-cloud" :style="{backgroundImage: 'url(' + publicPath + 'img/making/cloud.png)'}"></div>
        <div class="making-star" :style="{backgroundImage: 'url(' + publicPath + 'img/making/star.png)'}"></div>
        <div class="making-progress-box" :style="{backgroundImage: 'url(' + publicPath + 'img/making/progress-bg.png)'}">
          <div class="making-progress-outer" :style="{width: progerss * 0.11 + 'rem'}">
            <div class="making-progress-inner"></div>
          </div>
          <div class="making-progress-text-box" :style="{backgroundImage: 'url(' + publicPath + 'img/making/progress-box.png)', left: progerss * 0.96 + '%'}">
            <div class="making-progress-text">{{progerss}}%</div>
          </div>
        </div>
      </div>
    </div>

    <div class="poster" v-show="showPoster">
      <!-- <div style="">海报页</div> -->
      <div class="img-box">
        <img :src="poster" />
      </div>

      <div class="fixed-box" :style="{backgroundImage: 'url(' + publicPath + 'img/poster/fixed-item.jpg)'}">
        <div class="retry-btn" @click="retry"></div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import icons from '../utils/icons'

export default {
  name: 'Memory',
  components: {
    // HelloWorld
  },
  data () {
    return {
      showMemory: true, // 默认 true
      nickname: '你',
      headImage: '',
      autoScroll: null,
      scrollElmTouching: false,
      scrollProgress: 0,
      memorys: icons,
      iconSize: 60,
      // 制作中页面，过渡效果
      showMaking: false, // 默认 false
      progerss: 0, // // 制作进度数据，0-100
      // 海报页
      showPoster: false,
      slogan: '', // slogan
      poster: ''
    }
  },
  computed: {
    selectedMemorys () {
      // 被选中的记忆碎片
      return this.memorys.filter(t => {
        return t.status
      })
    }
  },
  watch: {
    showMaking (newValue, oldValue) {
      // console.log(newValue, oldValue)
      if (newValue) {
        document.querySelector('.making').style.display = 'block'
      } else {
        setTimeout(() => {
          document.querySelector('.making').style.display = 'none'
        }, 1000)
      }
    }
  },
  beforeCreate () {
  },
  mounted () {
    if (window.$wxuser && window.$wxuser.headimgurl) {
      // TODO 过滤昵称里的表情符号等，特殊字符
      this.nickname = window.$wxuser.nickname
      this.headImage = 'https://m.china.com.cn/thirdwx/' + window.$wxuser.headimgurl.replace('https://thirdwx.qlogo.cn/', '')
    }

    // 监听容器的状态
    // document.querySelector('.memory-box').addEventListener('touchstart', () => {
    // console.log('touch start')
    // this.scrollElmTouching = true
    // window.clearTimeout(waitForRescroll)
    // })
    document.querySelector('.memory-box').addEventListener('touchmove', () => {
      this.scrollElmTouching = true
    })
    document.querySelector('.memory-box').addEventListener('touchend', () => {
      // console.log('touch end')
      this.scrollElmTouching = false
    })

    // 延时启动自动滚动
    setTimeout(() => {
      this.autoScrollStart()
    }, 1000)

    if (window._czc) window._czc.push(['_trackEvent', '2020年终盘点-打开记忆碎片', 'pv', '', '', ''])
  },
  beforeDestroy () {
    // 在页面卸载前，注销自动滚动
    // console.log('beforeDestroy')
    window.clearInterval(this.autoScroll)
  },
  methods: {
    autoScrollStart () {
      // console.log('auto scroll')
      // 清理自动滚动，避免多次触发
      window.clearInterval(this.autoScroll)

      const parentHeight = document.querySelector('.memory-wrap').clientHeight
      const scrollHeight = document.querySelector('.memory-wrap').scrollHeight

      // console.log(document.querySelector('.memory-wrap').scrollTop, scrollHeight, parentHeight)
      this.autoScroll = setInterval(() => {
        // 手指滑动的时候，不要再自动滚动了
        if (this.scrollElmTouching) return false

        if (document.querySelector('.memory-wrap').scrollTop < scrollHeight - parentHeight) {
          document.querySelector('.memory-wrap').scrollTop += 1
        } else {
          // 只自动滚动一次
          window.clearInterval(this.autoScroll)
        }
      }, 1000 / 60)
    },
    select (id) {
      // 拾取记忆碎片的事件
      // console.log(id)
      this.memorys[id].status = !this.memorys[id].status

      if (window._czc) window._czc.push(['_trackEvent', '2020年终盘点-选择记忆碎片', 'pv', '', '', ''])
    },
    memoryScroll () {
      const memoryBoxHeight = document.querySelector('.memory-wrap div').clientHeight
      const parentHeight = document.querySelector('.memory-wrap').clientHeight
      const scrollTop = document.querySelector('.memory-wrap').scrollTop
      const progerss = scrollTop / (memoryBoxHeight - parentHeight) * 100
      if (progerss >= 0 && progerss <= 100) {
        this.scrollProgress = progerss
      } else if (progerss < 0) {
        this.scrollProgress = 0
      } else {
        this.scrollProgress = 100
      }
    },
    backToTop () {
      // 回到开头
      document.querySelector('.memory-box').scrollTop = 0

      // 等到1.5s后
      setTimeout(() => {
        // 启动自动滚动
        this.autoScrollStart()
      }, 1500)
    },
    makeMemory () {
      if (this.selectedMemorys.length > 0) {
        // 跳转页面前，停止自动滚动的定时器
        if (window.clearInterval) window.clearInterval(this.autoScroll)

        // 调用制作中的方法，开始绘制海报
        this.making()

        if (window._czc) window._czc.push(['_trackEvent', '2020年终盘点-制作海报', 'pv', '', '', ''])
      } else {
        this.$notice.showMessage({
          type: 'warning',
          message: '请先选择你的记忆碎片'
        })
      }
    },
    setSlogan () {
      const x = Math.floor(Math.random() * 7)
      const texts = [
        '纵有疾风起，人生不言弃。',
        '笑口常开，好彩自然来！',
        '我们遇到的困难越多，\n越能证明我们是勇敢的。',
        '不轻易被世界改变的人，\n才能改变这个世界。',
        '凡是经历，皆是馈赠，\n凡是过往，皆是序章。',
        '心中有爱，眼里有光。',
        '记忆，不管多么微不足道，\n都是定义我们的篇章。'
      ]
      this.slogan = texts[x]
    },
    // 制作中的进度显示
    showMakingProgress () {
      const anim = setInterval(() => {
        if (this.progerss < 99) {
          this.progerss++
        } else {
          this.progerss = 100
          window.clearInterval(anim)
        }
      }, 40)
    },
    // 展示制作中页过场动画，渲染海报，然后显示海报
    making () {
      this.showMaking = true

      // 制作中的进度条开始走
      this.showMakingProgress()

      // 设置海报上的slogan
      this.setSlogan()

      setTimeout(() => {
        this.showMemory = false

        const poster = document.querySelector('#factory')
        const width = poster.offsetWidth
        const height = poster.offsetHeight
        const canvas = document.createElement('canvas')
        const scale = 2 // 定义任意放大倍数 支持小数
        canvas.width = width * scale // 定义 canvas 宽度 * 缩放
        canvas.height = height * scale // 定义 canvas 高度 * 缩放
        canvas.getContext('2d').scale(scale, scale) // 获取context,设置scale

        window.html2canvas(document.querySelector('#factory'), {
          dpi: 300, // 加了一个这个设置，DPI越高，清晰度越高
          backgroundColor: '#2f2d4e', // 海报的背景颜色
          // backgroundColor: '#302c4e',
          scale: window.devicePixelRatio || 1, // 缩放比例
          canvas: canvas, // 自定义 canvas
          logging: true, // 日志开关
          width: width, // 海报的宽度
          height: height // 海报的高度
        }).then(canvas => {
          // document.querySelector('.making-tr').append(canvas)

          // 海报合成完了，也得等1s，不然太快了
          setTimeout(() => {
            this.poster = canvas.toDataURL('image/jpeg')
            // console.log(this.poster.length)

            // 渲染，并且完成，
            this.progerss = 100
            setTimeout(() => {
              this.showPoster = true

              // // 去掉making过场动画
              this.showMaking = false

              if (window._czc) window._czc.push(['_trackEvent', '2020年终盘点-显示海报', 'pv', '', '', ''])
            }, 800)
          }, 1000)
        }).catch(err => {
          console.log(err)
          this.$notice.showMessage({
            type: 'warning',
            message: '制作失败，请刷新页面重试'
          })
        })
      }, 500)
    },
    // 重启按钮，初始化页面
    retry () {
      this.showMemory = true
      this.showMaking = false
      this.showPoster = false
      this.poster = ''
      this.progerss = 0
      this.scrollElmTouching = false
      // 清空选中的记忆
      this.selectedMemorys.forEach(t => {
        t.status = false
      })

      this.$nextTick(() => {
        // 复原滚动条
        document.querySelector('.memory-wrap').scrollTop = 0
      })

      // 延时启动自动滚动
      setTimeout(() => {
        this.autoScrollStart()
      }, 1000)

      if (window._czc) window._czc.push(['_trackEvent', '2020年终盘点-点击重启', 'pv', '', '', ''])
    }
  }
}
</script>

<style lang="scss">
.memory {
  height: 100%;
  background-size: 100% auto;
  .head {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    width: 100%;
    height: 5.4rem;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: 50% 0;
    #found {
      position: absolute;
      top: .5rem;
      right: .7rem;
      border-radius: 50%;
      width: 1.1rem;
      height: 1.1rem;
      overflow: hidden;
      text-align: center;
      line-height: 1.1rem;
      font-family: sans-serif;
      font-weight: bold;
      font-size: .7rem;
      color: #000000;
    }
  }
}

.memory-box {
  position: absolute;
  top: 4rem;
  left: 6%;
  z-index: 8;
  width: 88%;
  height: 72.5%;
  max-height: 40rem;
  overflow: hidden;
  background-size: 100% 100%;
  text-align: left;
  .memory-wrap{
    position: absolute;
    top: 1%;
    left: 3%;
    z-index: 10;
    width: 100%;
    height: 98%;
    overflow: auto;
  }
  .memory-slider{
    position: absolute;
    top: 0;
    right: 0;
    z-index: 11;
    width: .6rem;
    height: 99%;
    background-size: auto 9.6rem;
    background-repeat: no-repeat;
    background-position: 0 0;
    transition: background-position .1s linear;
    -webkit-transition: background-position .1s linear;
  }
  .memory-birds{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    .bird-1{
      position: absolute;
      top: 2rem;
      left: 2rem;
      width: 3.03rem;
      height: 2.66rem;
    }
    .bird-2{
      position: absolute;
      top: 20rem;
      left: 14rem;
      width: 2.47rem;
      height: 3.03rem;
    }
  }
}

.memory-wrap .memory-item:first-child {
  margin-top: 8rem;
}
.memory-item {
  display: inline-block;
  position: relative;
  margin: .6rem .625rem;
  width: 15rem;
  .memory-icon-box {
    display: inline-block;
    border-radius: 50%;
    width: 4rem;
    height: 4rem;
    opacity: 0;
    background-size: 100% 100%;
  }
  .selected {
    opacity: 1;
  }
  .memory-content {
    position: absolute;
    left: 2.9rem;
    bottom: 0;
    z-index: 2;
    // border-radius: 5px;
    // padding: 5px 10px;
    max-width: 10rem;
    // background-color: white;
    .memory-content-box-bg{
      position: absolute;
      top: 5px;
      left: -5px;
      z-index: 3;
      border-radius: 3px;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(to right, rgb(242, 187, 140), rgb(251, 233, 167));
      background-image: -webkit-linear-gradient(to right, rgb(242, 187, 140), rgb(251, 233, 167));
      .white-bg-box {
        position: absolute;
        z-index: 3;
        box-sizing: border-box;
        border: solid 3px transparent;
        width: 100%;
        height: 100%;
        .white-bg {
          width: 100%;
          height: 100%;
          background-color: #ffffff;
        }
      }
    }
    .memory-content-box{
      position: relative;
      z-index: 3;
      border-radius: 3px;
      overflow: hidden;
      background-image: linear-gradient(to right, rgb(242, 187, 140), rgb(251, 233, 167));
      background-image: -webkit-linear-gradient(to right, rgb(242, 187, 140), rgb(251, 233, 167));
      .white-bg{
        position: absolute;
        z-index: 3;
        width: 100%;
        height: 100%;
      }
      .dot {
        position: absolute;
        z-index: 4;
        width: 4px;
        height: 4px;
        background-color: #3f527e;
      }
      .dot-1 {
        top: .3rem;
        left: .3rem;
      }
      .dot-2 {
        top: .3rem;
        right: .3rem;
      }
      .dot-3 {
        left: .3rem;
        bottom: .3rem;
      }.dot-4 {
        right: .3rem;
        bottom: .3rem;
      }
      .memory-text {
        position: relative;
        z-index: 4;
        margin: 3px;
        padding: .2rem .6rem;
        background-color: #ffffff;
        line-height: 1.06rem;
        font-family: 'slogan';
        font-size: .76rem;
        color: #3f527e;
        // color: rgb(42, 64, 110);
      }
    }
  }
  .memory-icon-wrap {
    position: absolute;
    top: .35rem;
    left: .35rem;
    z-index: 3;
    border-radius: 50%;
    // width: 3.3rem;
    // height: 3.3rem;
    overflow: hidden;
    background-size: 100% 100%;
    .memory-icon {
      // display: inline-block;
      margin: 3px;
      width: 3rem;
      height: 3rem;
      border-radius: 50%;
      background-size: 30rem auto;
      background-repeat: no-repeat;
    }
  }
}
.right {
  text-align: right;
  .memory-content {
    left: initial;
    right: 2.9rem;
    text-align: left;
    .memory-content .memory-content-box-bg {
      left: initial;
      right: -5px;
    }
  }
  .memory-icon-wrap {
    left: initial;
    right: .35rem;
  }
}

.make-cloud {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 9;
  width: 100%;
  // height: 9.16rem;
  height: 19.3%;
  background-size: 100% auto;
  background-position: 50% 0;
  background-repeat: no-repeat;
  .make-cloud-star{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: 100% auto;
    background-position: 50% 100%;
    background-repeat: no-repeat;
  }
}

.make-btn {
  position: absolute;
  left: 5.6rem;
  bottom: 1%;
  z-index: 10;
  width: 8.8rem;
  height: 4.3rem;
  background-size: 100% 100%;
}
// .grey {
  // filter: grayscale(0.65);
// }

.making{
  position: relative;
  top: 0;
  left: 0;
  z-index: 3;
  width: 100%;
  height: 100%;
  overflow: hidden;
  opacity: 0;
  transition: opacity 1s ease;
  -webkit-transition: opacity 1s ease;
  .making-tr{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .factory{
    position: relative;
    // background-color: rgb(47, 45, 78);
    background-color: #302c4e;
    background-size: 100% auto;
    background-position: 50% 100%;
    background-repeat: no-repeat;
    font-size: 0;
    .factory-bg{
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 1;
      width: 100%;
    }
    .head-box{
      position: relative;
      z-index: 2;
      height: 9.7rem;
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: 50% 0;
      .head-box-bg{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
      }
      .head-image{
        position: absolute;
        top: 1.1rem;
        left: 1.53rem;
        z-index: 2;
        width: 2.47rem;
        height: 2.44rem;
        background-size: 100%;
      }
      .head-nickname{
        position: absolute;
        left: 4.5rem;
        bottom: 6.16rem;
        z-index: 2;
        max-width: 14rem;
        text-align: left;
        line-height: 1.5;
        font-weight: bold;
        font-size: .7rem;
        color: rgb(255, 239, 143);
      }
    }
    .factory-icons{
      position: relative;
      z-index: 2;
      margin: 0 1.25rem;
      min-height: 12.5rem;
      text-align: left;
      font-size: 0;
      .factory-icon-item{
        display: inline-block;
        width: 4.375rem;
        min-height: 6.25rem;
        text-align: center;
        vertical-align: top;
        .factory-icon-box{
          display: inline-block;
          position: relative;
          border-radius: 50%;
          width: 3.3rem;
          height: 3.3rem;
          overflow: hidden;
          font-size: 0;
          // background-size: 100% 100%;
          // background-image: -webkit-linear-gradient(45deg, rgb(136, 68, 247), rgb(255, 239, 143));
          // background-image: linear-gradient(45deg, rgb(136, 68, 247), rgb(255, 239, 143));
          .factory-icon-bg{
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: 100%;
          }
          .factory-icon-wrap{
            position: relative;
            z-index: 2;
            margin: .15rem;
            border-radius: 50%;
            width: 3rem;
            height: 3rem;
            overflow: hidden;
            .factory-icon{
              position: absolute;
              width: 30rem;
              // display: inline-block;
              // width: 100%;
              // height: 100%;
              // background-size: 100% 100%;
            }
          }
        }
        .factory-icon-text{
          margin: .75rem auto;
          width: 4rem;
          line-height: 1.25rem;
          font-weight: bold;
          font-size: .625rem;
          color: #ffffff;
        }
      }
    }
    .factory-footer{
      position: relative;
      z-index: 2;
      height: 22rem;
      .factory-slogan{
        position: absolute;
        top: 6.24rem;
        right: 1rem;
        width: 11rem;
      }
      .factory-slogan-text{
        position: absolute;
        top: 6.4rem;
        right: 1rem;
        white-space: pre-wrap;
        text-align: left;
        font-family: 'slogan';
        font-size: 1rem;
        color: rgb(255, 239, 143);
      }
      .factory-qrcode{
        position: absolute;
        top: 15.6rem;
        right: 1rem;
        width: 3rem;
      }
      .factory-logo-area{
        display: -webkit-flex;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 3.04rem;;
        text-align: center;
        font-size: 0;
        .factory-logo{
          height: .8rem;
          position: relative;
          top: -.1rem;
        }
        & > .factory-logo:nth-child(1){
          margin-right: 1rem;
          height: 1rem;
          top: 0;
        }
        .factory-source{
          display: none;
          width: 9.16rem;
        }
      }
    }
  }
  .making-tr{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    width: 100%;
    height: 100%;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: 50% 0;
    .making-cloud{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      min-height: 39rem;
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: 50% 100%;
    }
    .making-star{
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 5;
      width: 100%;
      height: 100%;
      background-size: 100% auto;
      background-repeat: no-repeat;
      background-position: 50% 50%;
    }
    .making-progress-box {
      position: absolute;
      top: 16rem;
      left: 4.2rem;
      z-index: 6;
      width: 11.5rem;
      height: 1rem;
      background-size: 100% 100%;
      .making-progress-outer {
        position: absolute;
        top: .25rem;
        left: .25rem;
        border-radius: .5rem;
        width: 11rem;
        height: .5rem;
        overflow: hidden;
        transition: width .3s ease;
        -webkit-transition: width .3s ease;
        .making-progress-inner {
          width: 11rem;
          height: .5rem;
          background-image: -webkit-linear-gradient(to right, rgb(136, 68, 247), rgb(255, 239, 143));
          background-image: linear-gradient(to right, rgb(136, 68, 247), rgb(255, 239, 143));
        }
      }
      .making-progress-text-box {
        position: absolute;
        top: -2.4rem;
        left: 0%;
        width: 2.22rem;
        height: 2.22rem;
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: 50% 100%;
        transition: left .3s ease;
        -webkit-transition: left .3s ease;
        .making-progress-text {
          margin-top: .75rem;
          line-height: 1;
          font-weight: bold;
          font-size: .75rem;
          color: rgb(255, 239, 143);
        }
      }
    }
  }
}

.poster {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  overflow: auto;
  .img-box {
    font-size: 0;
    img {
      width: 100%;
      height: auto;
    }
  }
  .fixed-box {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 5;
    width: 100%;
    height: 3.04rem;
    background-size: 100% auto;
    background-position: 50% 100%;
    background-repeat: no-repeat;
    .retry-btn {
      position: absolute;
      top: 1rem;
      left: 2rem;
      width: 4.2rem;
      height: 2.2rem;
    }
  }
}
</style>
